export default __webpack_public_path__ + "static/HelveticaNeue-Bold-e06e17b7a751206d499fd4ec8445e080.woff";